const randNumbers = function(max = 5) {
  let min = 0
  let list = [1, 2, 3, 4, 5, 6, 7, 8, 9]

  return new Promise(resolve => {
    let num = ''
    for (min; min < max; min++) {
      let i = Math.floor(Math.random() * list.length)
      num += list[i]
    }

    return resolve(num)
  })
}

export { randNumbers }
